module.exports = __webpack_public_path__ + "img/roundtable-2.806d18ed.png";